"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapContextToNotificationTarget = void 0;
function mapContextToNotificationTarget(context) {
    return {
        targetUser: context.user ? { userId: context.user.id } : undefined,
        targetTeam: context.team && !context.campaign
            ? { teamId: context.team.id }
            : undefined,
        targetCampaign: context.campaign && context.team
            ? { campaignId: context.campaign.id, teamId: context.team.id }
            : undefined,
    };
}
exports.mapContextToNotificationTarget = mapContextToNotificationTarget;
